import * as  numeral from 'numeral'

const trillion = 1000000000000
const billion = 1000000000
const million = 1000000
const thousand = 1000
const Formatter = {
    toCurrency: (value, symbol) => {
        return numeral(value).format(`$0,0.00`)
    },
    toCurrencyTrim: (value, symbol) => {
      value = value || 0
      let abs = Math.abs(value)
      if (abs >= million) {
          return numeral(value).format(`$0,0[.][000]am`)
      } else {
          return numeral(value).format(`$0,0`)
      }
    },
    toDecimal: (value) => {
        value = value || 0
        let abs = Math.abs(value)
        if (abs >= million) {
            return numeral(value).format(`0,0[.][000]am`)
        } else {
            return numeral(value).format(`0,0[.][0000000000000000]`)
        }
    },
    toDecimalTrim: (value) => {
        value = value || 0
        let abs = Math.abs(value)
        if (abs >= million) {
            return numeral(value).format(`0,0[.][000]am`)
        } else {
            return numeral(value).format(`0,0[.][000]`)
        }
    }

}
export default {
    Formatter
}



// WEBPACK FOOTER //
// ./src/util/numberFormatter.js